import { COLORS } from "../../constants/colors";

export default function CommunityCategories({ onCategorySelect, industryGroups, learningGroups, myGroups }) {

  const categories = [
    {
      key: "industry",
      title: "Industry Groups",
      description: "Connect with professionals in your industry and explore emerging sectors.",
      icon: "👥",
      summary: `${industryGroups?.length || 0} Active Groups`,
      callToAction: "Join industry-specific communities"
    },
    {
      key: "learning",
      title: "Learning Groups",
      description: "Skill-based communities for continuous learning and development.",
      icon: "🎓",
      summary: `${learningGroups?.length || 0} Study Groups`,
      callToAction: "Learn together with peers"
    },
    {
      key: "my-groups",
      title: "My Groups",
      description: "Access your joined groups and participate in discussions.",
      icon: "💬",
      summary: `${myGroups?.length || 0} Joined`,
      callToAction: "Your community dashboard"
    },
  ];

  const handleCategoryClick = (categoryKey) => {
    onCategorySelect(categoryKey);
  };

  return (
    <div className="w-full min-h-screen">
      {/* Category Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {categories.map((cat) => (
          <div
            key={cat.key}
            onClick={() => handleCategoryClick(cat.key)}
            className="cursor-pointer mt-14 bg-white border border-gray-400 rounded-lg p-6 transition-all duration-200 hover:shadow-md"
          >
            {/* Icon */}
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: COLORS.purple }}>
                <span className="text-white text-xl">{cat.icon}</span>
              </div>
            </div>
            
            {/* Title */}
            <h3 className="text-lg font-bold text-gray-900 mb-2 text-center">
              {cat.title}
            </h3>
            
            {/* Description */}
            <p className="text-gray-600 text-sm mb-4 text-center leading-relaxed">
              {cat.description}
            </p>
            
            {/* Summary Badge */}
            <div className="flex justify-center mb-3">
              <span className="bg-gray-100 text-gray-900 px-3 py-1 rounded-md text-xs font-medium">
                {cat.summary}
              </span>
            </div>
            
            {/* Call to Action */}
            <p className="text-gray-500 text-xs text-center">
              {cat.callToAction}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
} 